import { asyncEmit } from '@/utils/socket';

export const useAuthSocket = () => {
    const rootPath = 'auth';
    const EMIT_CHANGE_CURRENCY = (
        data: { currency: string }, // 例如 {"currency": "usdt"} 
        callback: any,
    ) => {
        socket.emit(`${rootPath}.changeCurrency`, data, callback);
    };

    // ↓ 设定用户头像 
    const EMIT_NEW_AVATAR = (
        // 参数 avatar 是 URL，或默认头像的名称 
        data: { avatar: string },
    ) => {
        // 返回：{
        //     "msg": : 提示语
        //     "code": :结果0成功非0失败
        //     "callbackData"{ "avatar": avatar }
        // }
        const res = asyncEmit(
            `${rootPath}.changeAvatar`,
            data,
        );
        return res;
    };

    // 在账号冻结状态改变后会收到推送
    const ON_STATECHANGE = (callback: any) => {
        // locked | unlocked
        // ["userStateChanged",{"status":"unlocked"}]
        socket.on(`userStateChanged`, callback);
    };

    return {
        EMIT_CHANGE_CURRENCY,
        EMIT_NEW_AVATAR,
        ON_STATECHANGE,
    };
};

